<template>
	<div class="matters_list">		<!-- 搜索 --> 
    <el-form ref="baseForm" :rules="rules" :model="fromData">
    <search-box @subSearch="subSearch" :fromData="fromData">
      <el-form-item class="item" label="物料：" prop="codeOrDesc">
        <el-input  v-model="fromData.searchCriteria.codeOrDesc" :placeholder="$store.state.remark.matter"></el-input>
      </el-form-item>
    </search-box>
    </el-form>
		<!-- 列表 -->
    <tab-list
    setHeadBtn 
    ref="multipleTable"
    tabHeight="310"
    :selectedList="selectedMatterList"
    :tabList="listArr"
    :total="total"
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="matters-list"
    @getSelect="getSelect"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata">
    </tab-list>
	</div>
</template>
<script>
import {matterApi} from 'api/base.js';
import tabList from 'components/table/list.vue';
import searchBox from 'components/common/search.vue';
import { mapState, mapActions } from 'vuex'
export default{
  components:{
    tabList,searchBox
  },
	props:{},
  computed:{
    ...mapState("cache",['selectedMatterList'])
  },
	data(){
		return{
			sdata:{},
			listArr:[],//列表
      rules: {
        codeOrDesc:[{message: "",trigger: "blur"}],
      },
			tabColumns:[
			  {field: 'materialCode', title: '物料编码', width:100,"sortable":true},
			  {field: 'materialDesc', title: '物料描述'},
			  {field: 'materialTypeName', title: '物料类型', width:100},
			  {field: 'materialGroupDesc', title: '物料组', width:100},
			  {field: 'specifications', title: '规格', width: 100},
        {field: 'basicUnitDesc', title: '基本单位', width: 100},
			  {field: 'maintainStatus', title: '状态', width: 80,isHide:true,
			  formatter: function (rowData,rowIndex,pagingIndex,field) {
			    return rowData.maintainStatus === 'X' ? "已删除" : "正常";
			  }
			  }
			],//表头字段
			isDelList:false,//是否显示已删除的
			total:0,//总条数
			pages:0,//总页数
			fromData:{
				page:1,//当前页
				pageSize:10,//每页显示的数量,
				searchCriteria:{//查询的附加条件
				},
			}
		} 
	},
	watch:{

  },
	created(){
		this.getList();
	},
  updated(){
  },
	methods:{
    //选中数据
    selectSdata(data){
      this.$emit('getSelect',data);
    },
    //获取已选
    getSelect(res){
      // this.$emit('getSelect',res);
    },
    //取消选择
    cancelSelect(){
      this.$refs.multipleTable.cancelSelect();
    },
		//初始化需要获取的数据
		async getList(){
			let res = await this.$post(matterApi.list,this.fromData);
      if(res.status && res.data){
        console.log(res)
        res.data.list.map(item=>{
          return item.selectId = item.materialCode
        });
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      }else{
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
      }
      // this.$refs.multipleTable.changeTabListChecked();
		},
		//当前页码改变
		currentChange(currentPage){
			this.fromData.page = currentPage;
			this.getList();
		},
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
		//搜索按钮
		subSearch(){
			this.fromData.page = 1;
			this.getList();
		},
		handleSelectChange(item,key){
			if(item.isLock) return false;
			if(item.isChecked){
				item.isChecked = false;
				this.selectList.splice(key,1);
			}else{
				item.isChecked = true;
				this.selectList.push(item);
			}
		}
	}
}
</script>

<style>
</style>
